import { combineReducers } from "redux";
// import AccountTypeR from "../redusers/AccountTypeReduser";
import authReducer from "../redusers/AuthReducer";
// import FileR from "../redusers/FileReduser";
// import MainAccountR from "../redusers/MainAccountReduser";
// import FileDetailsR from "../redusers/FileDetailsReduser";
// import SupAccountR from "../redusers/SupAccountReduser";
// import SubuserR from "../redusers/AddSubuserReduser";
// import ManageAdminR from "../redusers/ManageAdminReduser";
import ClientR from "../redusers/ClientsReduser";
import AgencyR from "../redusers/AgencyReduser";
import AgencyTypeR from "../redusers/AgencyTypeReduser";
import AgencyStatusR from "../redusers/AgencyStatus";
import AgencyDestinationR from "../redusers/AgencyDestinationReduser";
import CourtR from "./CourtReduser";
import DawaR from "./dawaaReduser";
import AjendaR from "./AjendaReduser";
import ManageAdminR from "./ManageAdminReduser";
import UserSubscriptionR from "./UserSubscriptionReduser";
import ManageWorkR from "./ManageWorkReduser";
import ContactR from "./ContactReduser";
export default combineReducers({
  authReducer,
  ClientR,
  AgencyR,
  AgencyTypeR,
  AgencyStatusR,
  AgencyDestinationR,
  CourtR,
  DawaR,
  AjendaR,
  ManageAdminR,
  UserSubscriptionR,
  ManageWorkR,
  ContactR,
});
